// extracted by mini-css-extract-plugin
export default {"slider":"CustomSlider_slider__tchUw","thumb":"CustomSlider_thumb__Xgjfr"};